import React, { useState } from "react";
import TopBarButton from "../TopBarButton/TopBarButton";
import "./VolumeButton.css";


export default function VolumeButton() {
  const [volume, setVolume] = useState(true);
  const className = volume ? "fa fa-volume-up" : "fa fa-volume-off";
  function handleVolume() {
    setVolume(!volume);
  }
  return (
    <div className="volume-button">
      <TopBarButton className={className} onClick={() => handleVolume()} />
    </div>
  )
}